import { createContext, type ReactNode, useState } from 'react';
import { NAVBAR } from '../config';
import useResponsive from '../hooks/useResponsive';

export type CollapseDrawerContextProps = {
  isCollapse: boolean;
  onToggleCollapse: VoidFunction;
  setCollapse: (collapsed: boolean) => void;
};

const initialState: CollapseDrawerContextProps = {
  isCollapse: false,
  onToggleCollapse: () => {},
  setCollapse: () => {},
};

const CollapseDrawerContext = createContext(initialState);

type CollapseDrawerProviderProps = {
  children: ReactNode;
};

function CollapseDrawerProvider({ children }: CollapseDrawerProviderProps) {
  const isMobile = useResponsive('down', NAVBAR.MOBILE_BREAKPOINT);

  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleToggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <CollapseDrawerContext.Provider
      value={{
        isCollapse: isCollapsed && !isMobile,
        onToggleCollapse: handleToggleCollapse,
        setCollapse: setIsCollapsed,
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}

export { CollapseDrawerProvider, CollapseDrawerContext };
